import React, { useEffect, useRef } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { logoutUser } from "../../redux/auth/authSlice";

const InactivityTimeoutHOC = (WrappedComponent, timeoutDuration) => {
  return function WithInactivityTimeout(props) {
    const dispatch = useAppDispatch();
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
      const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          dispatch(logoutUser());
        }, timeoutDuration);
      };

      resetTimer();
      document.addEventListener("mousemove", resetTimer);
      document.addEventListener("keydown", resetTimer);
      document.addEventListener("mousedown", resetTimer);
      document.addEventListener("touchstart", resetTimer);

      return () => {
        document.removeEventListener("mousemove", resetTimer);
        document.removeEventListener("keydown", resetTimer);
        document.removeEventListener("mousedown", resetTimer);
        document.removeEventListener("touchstart", resetTimer);
        if (timerRef.current) clearTimeout(timerRef.current);
      };
    }, [dispatch, timeoutDuration]);

    return <WrappedComponent {...props} />;
  };
};

export default InactivityTimeoutHOC;
